export default __webpack_public_path__ + "static/media/archive.a5190d8b.svg";